const d = 'M480-344 240-584l43-43 197 197 197-197 43 43-240 240Z';

export default d;
